/* eslint-disable no-shadow,object-curly-newline */

import User from './model/User';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const APPTOKEN = 'roomsched.web.jwt';

const MutationTypes = {
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT'
};

const state = {
    user: User.from(localStorage[APPTOKEN])
};

const getters = {
    appToken() {
        return APPTOKEN;
    },
    currentUser(state) {
        return state.user;
    }
};

const mutations = {
    [MutationTypes.LOGIN](state) {
        state.user = User.from(localStorage[APPTOKEN]);
    },
    [MutationTypes.LOGOUT](state) {
        state.user = null;
    }
};

const actions = {
    login({commit}) {
        commit(MutationTypes.LOGIN);
    },
    logout({commit}) {
        commit(MutationTypes.LOGOUT);
    }
};

export default new Vuex.Store({
    state,
    mutations,
    getters,
    actions
});